import Store from '../Store';
import Template from '../../data/ressources/Template.json'

const TemplateStore = new Store('sourcing/templates', Template);

export {TemplateStore};